// @flow

import React from 'react';
import { Card, Text, Icon, Button } from '../';
import Bullet from './Bullet';
import AlertWrapper from './AlertWrapper';
import { getIcon, getColor } from './getUi';

type Props = {
  type: 'success' | 'warning' | 'danger' | 'info',
  title: String,
  description: String,
  buttons: Array,
  show: Boolean,
  buttonsClassName: String,
};

export function ConfirmAlert({
  type,
  icon,
  show,
  title,
  description,
  buttons,
  buttonsClassName = '',
}: Props) {
  return (
    <AlertWrapper show={show}>
      <Card
        hasBorder={false}
        type="white"
        className="flex-center-between flex-column position-relative mw-40 mh-11"
        maxWidth="90%"
      >
        {title && (
          <Text size="lg" className="mt-5 px-2">
            {title}
          </Text>
        )}
        {description && (
          <Text size="pxxlg" className="my-3 px-3">
            {description}
          </Text>
        )}
        <div className="d-flex flex-row w-100 overflow-auto radius-br-md radius-bl-md mt-2">
          {buttons.map(({ type, className, callBack, title }, index) => (
            <Button
              borderRadius="0"
              className={`w-100 justify-content-center d-flex pointer py-2 px-0 ${buttonsClassName} ${className}`}
              type={type}
              onClick={(_) => callBack()}
              radius={0}
              text={title}
              textColor="white"
              key={index}
            />
          ))}
        </div>
        <Bullet color={getColor(type)}>
          <Icon name={getIcon(icon, type)} size={30} color="white" />
        </Bullet>
      </Card>
    </AlertWrapper>
  );
}
